import { render, staticRenderFns } from "./ConnectedBanksConclusion.vue?vue&type=template&id=cda484e6&scoped=true&"
import script from "./ConnectedBanksConclusion.vue?vue&type=script&lang=js&"
export * from "./ConnectedBanksConclusion.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedBanksConclusion.vue?vue&type=style&index=0&id=cda484e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda484e6",
  null
  
)

export default component.exports